import { FC, ReactNode, useState } from 'react';
import './layout.scss';
import { getversion } from '../version';
import { LoginPage } from '../pages/login';
import { getUsername } from '../services/auth.header';
import { useAuthContext } from '../services/auth.service';

/* -------------------------------------------------------------------------------- *\
|                               LayoutSite
\* -------------------------------------------------------------------------------- */
export const LayoutSite: FC<{ children?: ReactNode }> = (children) =>
{
    const version = getversion();
    const auth = useAuthContext();
    const username = getUsername();
    const [route] = useState<string>(window.location.pathname);

    /* -------------------------------------------------------------------------------- *\
    |                               isactive
    \* -------------------------------------------------------------------------------- */
    function isactive(path: string): boolean
    {
        return route === path || (path === '/logs' && route === '/');
    }

    if (!auth || !auth.token)
    {
        return <LoginPage />;
    }

    return (
        <div className="layout">
            <div className="layout__sider">
                <div className="layout__logo">
                    <a href="/"><img src="/images/favicon/android-icon-96x96.png" alt="McLloyd" /></a>
                </div>
                <div className="layout__username" title={username}>{username}</div>
                <div className="layout__menucont">
                    <div className="layout__menu">
                        <a className={'layout__menu__item' + (isactive('/logs') ? ' layout__menu__item__active' : '')} href="/logs">
                            <p className="layout__menu__item__text">Logs</p>
                        </a>
                    </div>
                    <div className="layout__menu layout__menu__bottom">
                        <div className="layout__menu__item" onClick={() => auth.logout()}>
                            <p className="layout__menu__item__text">Logout</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="layout__content">
                <div className="layout__content__inner">
                    <div>{children.children}</div>
                </div>
                <div className="layout__footer">{version}</div>
            </div>
        </div>
    );
}
